jQuery(document).ready(function($){

    if ( $('.nf-testimonial-slider-block') ) {
        var slider = $('.nf-testimonial-slider-block .nf-testimonial-slider-block__wrapper');
        var nextbut = slider.parent().find('.next-btn');
        $('.nf-testimonial-slider-block .nf-testimonial-slider-block__wrapper').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: '',
            nextArrow: nextbut,
            dots: false,
            fade: true
        });

        var $progressBar = $('.progress');
        var $progressBarLabel = $( '.slider__label' );
        var $curSlideLabel = $('.slider__label__current');
        var $totalSlideLabel = $('.slider__label__total');

        slider.on('reInit', function(slick) {
            $totalSlideLabel.text( slick.slideCount );
        });
        
        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
          $totalSlideLabel.text( slick.slideCount );
          var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
          
          $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc );
          
          $progressBarLabel.text( calc + '% completed' );
          $curSlideLabel.text( nextSlide + 1);
         
        }); 
    }

    if($('.nf-client-grid__slider').length > 0) {
        var slider = $('.nf-client-grid__slider');
        $(slider).slick({
            slidesToScroll: 1,
            slidesToShow: 5,
            arrows: false,
            dots: false,
            fade: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed:2000,
            cssEase:'linear',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
            ]
        });
    }

    if($('.nf-training-programs__slides').length > 0) {
        var slider = $('.nf-training-programs__slides');
        var nextbtn = $('.nf-training-programs__slides').parent().find('.nextbtn');
        $(slider).slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: '',
            nextArrow: nextbtn,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                    }
                },
            ]
        });

        $(slider).on("afterChange", function (){
            curid = $(".slick-current .nf-training-programs__slide").attr('id');
            id = curid.replace('slide-', '');
            strapid = "strapline-" + id;
            $(".nf-training-programs__strapline").removeClass('active');
            $("#" + strapid).addClass('active');
        });

        $(".nf-training-programs__strapline").on("click", function(){
            id = $(this).attr('id');
            id = id.replace('strapline-', '');
            slider.slick('slickGoTo', id - 1);
        });
    }
});


    
    
        